import { Injectable } from '@angular/core';
import { BaseClient } from '../common/client/base.client';
import { SvcClients } from '../common/client/SvcClients';

@Injectable({
  providedIn: 'root',
})
export class FinanceClient extends BaseClient {
  constructor() {
    super();
  }

  proccessRawBankStatements(model: any, message: string) {
    return this.post(
      SvcClients.AdminSvc,
      `PDAPTabapayReconciliation/ProcessLoadedBankStatements`,
      model,
      message
    );
  }

  reprocessLoadedBankStatement(model: any, message: string) {
    return this.post(
      SvcClients.AdminSvc,
      `PDAPTabapayReconciliation/ReprocessLoadedBankStatement`,
      model,
      message
    );
  }

  getBankStatements(model: any, message: string) {
    return this.post(
      SvcClients.AdminSvc,
      `PDAPTabapayReconciliation/GetBankStatements`,
      model,
      message
    );
  }

  reprocessBankStatement(model: any, message: string) {
    return this.post(
      SvcClients.AdminSvc,
      `PDAPTabapayReconciliation/ReprocessBankStatement`,
      model,
      message
    );
  }

  getReconciledTransactionsReport(model: any, message: string) {
    return this.post(
      SvcClients.AdminSvc,
      `PDAPTabapayReconciliation/GetReconciledTransactionsReport`,
      model,
      message
    );
  }

  getReconciledTransactionsByCustomerReport(model: any, message: string) {
    return this.post(
      SvcClients.AdminSvc,
      `PDAPTabapayReconciliation/GetReconciledTransactionsByCustomerReport`,
      model,
      message
    );
  }

  getUnreconciledTransactionsReport(model: any, message: string) {
    return this.post(
      SvcClients.AdminSvc,
      `PDAPTabapayReconciliation/GetUnreconciledTransactionsReport`,
      model,
      message
    );
  }

  getMerchants() {
    return this.get(
      SvcClients.AdminSvc,
      `PDAPTabapayReconciliation/GetMerchants`
    );
  }

  //#region -------Dashboard: server-side paging + aggregates

  getReconciledTransactionsReportPaged(model: any, message: string) {
    return this.post(
      SvcClients.AdminSvc,
      `PDAPTabapayReconciliation/GetReconciledTransactionsReportPaged`,
      model,
      message
    );
  }

  getReconciledTransactionsByCustomerReportPaged(model: any, message: string) {
    return this.post(
      SvcClients.AdminSvc,
      `PDAPTabapayReconciliation/GetReconciledTransactionsByCustomerReportPaged`,
      model,
      message
    );
  }

  getUnreconciledTransactionsReportPaged(model: any, message: string) {
    return this.post(
      SvcClients.AdminSvc,
      `PDAPTabapayReconciliation/GetUnreconciledTransactionsReportPaged`,
      model,
      message
    );
  }

  getReconciledAggregates(model: any, message: string) {
    return this.post(
      SvcClients.AdminSvc,
      `PDAPTabapayReconciliation/GetReconciledAggregates`,
      model,
      message
    );
  }

  getByCustomerAggregates(model: any, message: string) {
    return this.post(
      SvcClients.AdminSvc,
      `PDAPTabapayReconciliation/GetByCustomerAggregates`,
      model,
      message
    );
  }

  getUnreconciledAggregates(model: any, message: string) {
    return this.post(
      SvcClients.AdminSvc,
      `PDAPTabapayReconciliation/GetUnreconciledAggregates`,
      model,
      message
    );
  }
  //#endregion

  //#region -------Dashboard / AI analyze tab

  getTurnoverEarningsDashboard(model: any, message: string) {
    return this.post(
      SvcClients.AdminSvc,
      `PDAPTabapayReconciliation/GetTurnoverEarningsDashboard`,
      model,
      message
    );
  }

  getReconciliationDashboard(model: any, message: string) {
    return this.post(
      SvcClients.AdminSvc,
      `PDAPTabapayReconciliation/GetReconciliationDashboard`,
      model,
      message
    );
  }

  // AI analysis for the dashboard PDF — proxied through ResourceService to AIProxyAPI (Bedrock).
  getDashboardAiAnalysis(model: any, message: string) {
    return this.post(
      SvcClients.ResourceSvc,
      `PDAPTabapayReconAnalysis/GetDashboardAnalysis`,
      model,
      message
    );
  }
  //#endregion
}
